import { useContext } from 'react';

import { RolesAndPermissionsContext } from 'context/RolesAndPermissionsContext';

const CanUser = ({ type, reverse, customList, user, children }) => {
    const rolesAndPermissions = useContext(RolesAndPermissionsContext);

    const testResult = rolesAndPermissions?.canUser(type, customList, user);

    if (testResult && !reverse) {
        return children;
    }

    if (!testResult && reverse) {
        return children;
    }

    return null;
}

export default CanUser;
